import styled from 'styled-components';

export const Wrapper = styled.div<{ selected: boolean }>`
  width: 100%;

  padding: 12px;

  background: ${props =>
    props.selected ? `${props.theme.colors.primary.main}10` : '#ffffff'};

  border-radius: 8px;

  gap: 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  overflow: hidden;
  position: relative;

  svg {
    width: 18px;
    height: 18px;

    path,
    rect {
      fill: ${props =>
        props.selected
          ? `${props.theme.colors.primary.main}`
          : props.theme.colors.text.secondary};
    }
  }

  &:hover {
    span {
      color: ${props => props.theme.colors.primary.main};
    }

    svg {
      path,
      rect {
        fill: ${props => props.theme.colors.primary.main};
      }
    }
  }
`;
